import { useEffect } from "react";
import { Helmet } from "react-helmet";
import Footer from "../../Component/Footer/Footer";
import AIheader from "../RentAI/AIheader";
import { HomeHero } from "./components/HomeHero";
import { HomeShowcase } from "./components/HomeShowcase";
import { ProductRail } from "./components/ProductRail";
import "./home.css";

const DEFAULT_TITLE = "Rentid — The rental operating system for independent hosts";
const DESCRIPTION =
  "Run your own direct rental business on Rentid. Your brand, your customers, your terms — bookings, agreements, payments, and protection in one place.";

/* Rentid home page, ported from the v0 prototype's /home page. Everything inside
   `.rd-home` uses the scoped Tailwind build (tailwind.config.js) and home.css; the
   site footer stays outside the wrapper so it keeps the styling shared with every
   other page.

   Also the shell for home-page variants (v0 duplicates the home page with a different hero,
   e.g. /inshur): pass `hero`, `title` and `path`. A variant hero must keep
   id="home-hero" on its <section> (ProductRail stays hidden while it is on screen) and must
   live under src/pages/Home/ so the scoped Tailwind build sees its classes. */
export default function Home({ hero = <HomeHero />, title = DEFAULT_TITLE, path = "/" }) {
  const url = `https://www.rentid.io${path}`;
  // Pages on this site reset scroll themselves (scrollRestoration is manual).
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);


  return (
    <>
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={DESCRIPTION} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={DESCRIPTION} />
        <meta property="og:url" content={url} />
        <link rel="canonical" href={url} />
      </Helmet>
      {/* Shared site header. The wrapper class keeps it transparent at rest so the hero shows through;
          it still turns black when scrolled or when a menu is open (rd-site.css). */}
      <div className="rd-home-header">
        <AIheader />
      </div>
      <div className="rd-home">
        <main className="home-fade-in min-h-screen overflow-x-hidden bg-black">
          {hero}
          <HomeShowcase />
        </main>
        {/* Left product rail (fixed): slides in once the rentDirect section is on screen. Kept
            outside <main>: main's fade-in animation makes it a stacking context, which trapped
            the rail under the footer at the bottom of the page. */}
        <ProductRail />
      </div>
      <Footer />
    </>
  );
}
